/* DECKWAECHTER - Urlaubs-/Versandhinweis + Gratis-Zugabe 2026
 * 1) Banner: Urlaubspause, Versand ab 01.08.2026, Gratis-Zugabe ab 9,99 EUR.
 * 2) Entschaerft die Tempo-Versprechen ("Schneller Versand" etc.).
 *
 * Die Zugabe (100 Perfect Fit Penny Sleeves) legt Marco beim Packen manuell bei.
 * Bewusst KEIN Warenkorb-/Rabatt-Automatismus: kein Bestandsfehler waehrend des Urlaubs.
 *
 * Preis-Aussagen ("Kostenloser Versand ab 29,99 EUR") bleiben unangetastet -
 * das sind Preis-, keine Zeitaussagen und bleiben wahr.
 * "Schnell zum Ziel" ist die Kategorie-Navigation, KEIN Versandversprechen -> nicht anfassen.
 *
 * WICHTIG: Aendert NICHTS dauerhaft am Theme. Ab END_DATE ist automatisch
 * wieder alles im Originalzustand - kein manueller Rueckbau noetig.
 *
 * Vorschau vor Go-Live: ?dwpreview=1 an die URL haengen.
 */
(function () {
  if (window.__dwUrlaub) return;
  window.__dwUrlaub = true;

  var LIVE = true;                          // auf true = oeffentlich sichtbar
  var END_DATE = new Date('2026-08-01T00:00:00+02:00');
  var PREVIEW = location.search.indexOf('dwpreview=1') !== -1;

  if (!PREVIEW) {
    if (!LIVE) return;
    if (new Date() >= END_DATE) return;      // Urlaub vorbei -> alles wie vorher
  }

  /* ---------- 1. Banner ---------- */

  var CSS = [
    '.dw-urlaub{position:sticky;top:0;z-index:9999;width:100%;',
    'background:linear-gradient(100deg,#140805 0%,#2A0E07 50%,#4A1509 100%);',
    'color:#fff;font-family:Inter,system-ui,-apple-system,Segoe UI,sans-serif;',
    'box-shadow:0 2px 20px rgba(0,0,0,.55);border-bottom:3px solid #FF6A00;}',
    '.dw-urlaub__in{max-width:1200px;margin:0 auto;padding:14px 20px;display:flex;',
    'align-items:center;justify-content:center;gap:16px;text-align:center;flex-wrap:wrap;}',
    '.dw-urlaub__icon{font-size:30px;line-height:1;flex:0 0 auto;}',
    '.dw-urlaub__txt{display:flex;flex-direction:column;gap:4px;align-items:center;}',
    '.dw-urlaub__h{font-family:Oswald,Inter,sans-serif;font-size:19px;font-weight:700;',
    'letter-spacing:.6px;text-transform:uppercase;}',
    '.dw-urlaub__h em{font-style:normal;background:linear-gradient(90deg,#FF3B2F,#FF6A00);',
    '-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}',
    '.dw-urlaub__s{font-size:14px;font-weight:500;opacity:.92;}',
    '.dw-urlaub__s b{color:#FF8A3D;font-weight:800;}',
    '.dw-urlaub__gift{margin-top:3px;display:inline-flex;align-items:center;gap:8px;',
    'background:linear-gradient(90deg,#FF3B2F,#FF6A00);color:#fff;font-size:13px;font-weight:800;',
    'padding:6px 14px;border-radius:999px;box-shadow:0 2px 12px rgba(255,90,20,.45);}',
    '@media(max-width:700px){',
    '.dw-urlaub__in{padding:11px 12px;gap:9px;}',
    '.dw-urlaub__icon{font-size:23px;}',
    '.dw-urlaub__h{font-size:14px;}',
    '.dw-urlaub__s{font-size:12px;}',
    '.dw-urlaub__gift{font-size:11px;padding:5px 10px;}}'
  ].join('');

  function mountBanner() {
    if (document.querySelector('.dw-urlaub')) return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var bar = document.createElement('div');
    bar.className = 'dw-urlaub';
    bar.setAttribute('role', 'status');

    var inner = document.createElement('div');
    inner.className = 'dw-urlaub__in';

    var icon = document.createElement('div');
    icon.className = 'dw-urlaub__icon';
    icon.textContent = '🎁';

    var txt = document.createElement('div');
    txt.className = 'dw-urlaub__txt';

    var h = document.createElement('div');
    h.className = 'dw-urlaub__h';
    h.innerHTML = 'Urlaubspause – <em>Bestellen geht weiter!</em>';

    var s = document.createElement('div');
    s.className = 'dw-urlaub__s';
    s.innerHTML = 'Du kannst ganz normal bestellen. Der Versand aller Bestellungen erfolgt ab dem <b>1. August 2026</b>.';

    var gift = document.createElement('div');
    gift.className = 'dw-urlaub__gift';
    gift.textContent = '🎉 Jetzt bestellen & 100 Perfect Fit Sleeves gratis dazu – ab 9,99 € Bestellwert';

    txt.appendChild(h);
    txt.appendChild(s);
    txt.appendChild(gift);
    inner.appendChild(icon);
    inner.appendChild(txt);
    bar.appendChild(inner);

    document.body.insertBefore(bar, document.body.firstChild);
  }

  /* ---------- 2. Tempo-Versprechen entschaerfen ---------- */

  var RULES = [
    ['Wir versenden schnell und zuverlässig mit DHL aus Deutschland.',
     'Wir versenden ab dem 1. August 2026 zuverlässig mit DHL aus Deutschland.'],
    ['schneller Versand mit DHL aus Deutschland',
     'Versand ab 01.08.2026 mit DHL aus Deutschland'],
    ['Schnell & zuverlässig aus Deutschland',
     'Zuverlässig aus Deutschland – Versand ab 01.08.'],
    ['Schneller Versand',
     'Versand ab 01.08.2026']
  ];

  var NEEDLES = ['Wir versenden schnell', 'schneller Versand mit DHL',
                 'Schnell & zuverlässig aus Deutschland', 'Schneller Versand'];

  function skip(el) {
    if (!el) return true;
    var tag = el.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return true;
    if (el.closest('.dw-urlaub')) return true;
    return false;
  }

  function patchTexts(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n, todo = [];
    while ((n = w.nextNode())) {
      if (skip(n.parentElement)) continue;
      var v = n.nodeValue;
      var hit = false;
      for (var i = 0; i < NEEDLES.length; i++) {
        if (v.indexOf(NEEDLES[i]) !== -1) { hit = true; break; }
      }
      if (hit) todo.push(n);
    }
    todo.forEach(function (node) {
      var v = node.nodeValue;
      RULES.forEach(function (r) { v = v.split(r[0]).join(r[1]); });
      if (v !== node.nodeValue) node.nodeValue = v;
    });
    return todo.length;
  }

  /* ---------- Start ---------- */

  function boot() {
    mountBanner();
    patchTexts(document.body);
    var t = null;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { patchTexts(document.body); }, 120);
    });
    obs.observe(document.body, {childList: true, subtree: true});
  }

  if (document.body) {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
